import Link from '@mui/material/Link';
import { Box, Stack, Tooltip, Typography } from '@mui/material';

import { RouterLink } from 'src/routes/components';

import { truncateText } from 'src/pages/chat/utils/text-formatting';

// ----------------------------------------------------------------------

type RowCellLinkProps = {
  value: string;
  href: string;
  isSelectRecordDialog?: boolean;
  isSupportReport?: boolean;
};

// ----------------------------------------------------------------------

export function RowCellLink({
  value,
  href,
  isSelectRecordDialog = false,
  isSupportReport = false,
}: RowCellLinkProps) {
  const updatedValue =
    value && value.length > 20 ? (
      <Tooltip title={value}>
        <Typography component="span" sx={{ fontSize: 'inherit' }}>
          {truncateText(value, 20)}
        </Typography>
      </Tooltip>
    ) : (
      value
    );

  return (
    <Box sx={{ gap: 2, display: 'flex', alignItems: 'center' }}>
      <Stack sx={{ typography: 'body2', flex: '1 1 auto', alignItems: 'flex-start' }}>
        {isSelectRecordDialog || isSupportReport ? (
          <Box>{updatedValue}</Box>
        ) : (
          <Link
            component={RouterLink}
            href={href}
            color="inherit"
            sx={{
              cursor: 'pointer',
              transition: 'all 0.2s ease-in-out',
              '&:hover': {
                color: 'primary.main',
                transform: 'translateX(4px)',
              },
            }}
          >
            {updatedValue}
          </Link>
        )}
      </Stack>
    </Box>
  );
}
